"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataRequestLink = void 0;
const getPrivacyPortalUrl_1 = require("./getPrivacyPortalUrl");
function getDataRequestLink(newsroom, currentLocale) {
    return (newsroom.custom_data_request_link ||
        (0, getPrivacyPortalUrl_1.getPrivacyPortalUrl)(newsroom, currentLocale, {
            action: 'data-request',
        }));
}
exports.getDataRequestLink = getDataRequestLink;
//# sourceMappingURL=getDataRequestLink.js.map